export enum ExtendedInspectionDimensionSrcCollection {
  INSPECTION_DIMENSIONS = 'inspectionDimensions',
  OPERATION_DIMENSIONS = 'operationDimensions',
  HANDLING_UNIT_DIMENSIONS = 'handlingUnitDimensions',
  INSPECTION_DIMENSIONS_HISTORY = 'inspectionDimensionHistory',
}
